import SEOHead from '@/components/common/SEOHead';
const TermsOfServicePage = () => {
  return (
    <div className="bg-m2-background">
      <SEOHead
        title="Chính sách bảo mật | Trung tâm M2MBA"
        description="Chính sách bảo mật của Trung tâm M2MBA mô tả cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của học viên, đối tác và khách truy cập."
        url="/terms-of-service"
        type="website"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "website",
          "name": "Chính sách bảo mật | Trung tâm M2MBA",
          "url": "https://m2mba.com/privacy-policy",
          "description": "Điều khoản dịch vụ của Trung tâm M2MBA quy định quyền và nghĩa vụ của học viên, đối tác và khách truy cập khi sử dụng dịch vụ đào tạo.",
          "publisher": {
            "@type": "EducationalOrganization",
            "name": "M2MBA Academy",
            "url": "https://m2mba.com",
            "logo": {
              "@type": "ImageObject",
              "url": "https://storage.googleapis.com/m2mba/f4872d86-57b4-4bb8-9492-f14a60f22280.jpg"
            },
             "sameAs": [
                "https://www.facebook.com/profile.php?id=100063494024929",
                "https://zalo.me/0983213076"
            ]
          }
        }}
      />
      <div className="eh-container py-16 sm:py-24">
        <div className="mx-auto max-w-3xl rounded-eh bg-m2-surface-lowest p-6 shadow-eh-soft sm:p-10">
          <p className="eh-eyebrow">Thông tin pháp lý</p>
          <h1 className="eh-display text-4xl sm:text-5xl mb-8">
            Điều khoản dịch vụ
          </h1>
          
          <div className="prose prose-lg prose-gray max-w-none">
            <p className="text-lg leading-8 text-m2-on-surface-variant mb-8">
              Các điều khoản này điều chỉnh mối quan hệ giữa bạn (người sử dụng dịch vụ) và Trung tâm M2MBA (sau đây gọi là "chúng tôi" hoặc "trung tâm"). Bằng việc truy cập và sử dụng dịch vụ của chúng tôi, bạn đồng ý tuân thủ các điều khoản sau.
            </p>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                1. Các điều khoản chung
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Tính hợp lệ:
                  </h3>
                  <p className="text-m2-on-surface">
                    Bằng cách sử dụng trang web và đăng ký các khóa học của chúng tôi, bạn cam kết mình đã đủ tuổi và có đầy đủ năng lực pháp lý để ký kết hợp đồng.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Thay đổi điều khoản:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi có quyền thay đổi các điều khoản này bất cứ lúc nào. Các thay đổi sẽ được thông báo trên website và có hiệu lực ngay lập tức. Việc bạn tiếp tục sử dụng dịch vụ đồng nghĩa với việc bạn chấp nhận các điều khoản đã được cập nhật.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                2. Quyền và trách nhiệm của người học
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Đăng ký và thanh toán:
                  </h3>
                  <p className="text-m2-on-surface">
                    Bạn cam kết cung cấp thông tin cá nhân chính xác và đầy đủ khi đăng ký khóa học. Học phí phải được thanh toán đúng hạn theo quy định của trung tâm.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Hành vi trong lớp học:
                  </h3>
                  <p className="text-m2-on-surface">
                    Bạn có trách nhiệm tuân thủ nội quy lớp học, bao gồm việc tôn trọng giảng viên và các học viên khác, không có hành vi làm gián đoạn buổi học.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Sử dụng tài liệu:
                  </h3>
                  <p className="text-m2-on-surface">
                    Tài liệu khóa học do chúng tôi cung cấp chỉ dành cho mục đích học tập cá nhân. Bạn không được phép sao chép, phân phối, hoặc sử dụng các tài liệu này cho mục đích thương mại mà không có sự đồng ý bằng văn bản của trung tâm.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Bảo mật tài khoản:
                  </h3>
                  <p className="text-m2-on-surface">
                    Bạn có trách nhiệm bảo mật thông tin tài khoản cá nhân. Nghiêm cấm chia sẻ tài khoản học tập với bất kỳ người nào khác. Nếu phát hiện hành vi này, tài khoản của bạn sẽ bị hủy vĩnh viễn và không được hoàn lại học phí.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                3. Quyền và trách nhiệm của trung tâm
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Cung cấp dịch vụ:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi cam kết cung cấp các khóa học và tài liệu giảng dạy chất lượng, đúng như mô tả.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Hỗ trợ:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi sẽ cung cấp sự hỗ trợ cần thiết cho học viên trong suốt quá trình học.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-m2-on-surface mb-2">
                    Bảo mật thông tin:
                  </h3>
                  <p className="text-m2-on-surface">
                    Chúng tôi cam kết bảo mật thông tin cá nhân của bạn theo chính sách bảo mật đã công bố.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                4. Quyền sở hữu trí tuệ
              </h2>
              <p className="text-m2-on-surface">
                Tất cả nội dung trên website và trong các khóa học, bao gồm văn bản, hình ảnh, video, và tài liệu giảng dạy, đều thuộc sở hữu trí tuệ của chúng tôi hoặc các bên cấp phép. Nghiêm cấm mọi hành vi sao chép, tái bản hoặc sử dụng trái phép các nội dung này.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                5. Giới hạn trách nhiệm
              </h2>
              <div className="space-y-4">
                <p className="text-m2-on-surface">
                  Chúng tôi không chịu trách nhiệm về bất kỳ thiệt hại trực tiếp, gián tiếp hoặc ngẫu nhiên nào phát sinh từ việc bạn sử dụng hoặc không thể sử dụng dịch vụ của chúng tôi.
                </p>
                <p className="text-m2-on-surface">
                  Chúng tôi không đảm bảo rằng việc tham gia khóa học sẽ đảm bảo bạn có được việc làm hoặc thành công trong sự nghiệp. Kết quả phụ thuộc vào nỗ lực cá nhân của mỗi học viên.
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-m2-on-surface mb-6">
                6. Giải quyết tranh chấp
              </h2>
              <div className="space-y-4">
                <p className="text-m2-on-surface">
                  Mọi tranh chấp phát sinh từ hoặc liên quan đến các điều khoản này sẽ được giải quyết trước hết bằng phương thức thương lượng và hòa giải.
                </p>
                <p className="text-m2-on-surface">
                  Nếu không thể giải quyết bằng thương lượng, tranh chấp sẽ được đưa ra Tòa án có thẩm quyền tại Việt Nam để giải quyết.
                </p>
              </div>
            </section>

            <div className="eh-panel eh-panel-sage p-6 mt-8">
              <p className="text-sm text-m2-on-surface-variant">
                <strong>Liên hệ:</strong> Nếu bạn có bất kỳ câu hỏi nào về các điều khoản dịch vụ này, vui lòng liên hệ với chúng tôi qua email hoặc số điện thoại được cung cấp trên website.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfServicePage